import React from 'react'
import { dateConvert } from '../../utils/Helper'

const AssetAllocation = ({ data, onPrev, onNext, readOnly }) => {

    return (
        <div className='my-2'>
            <h4 className="p-2" style={{ background: "#f2f2f2" }}>IT Asset Allocation</h4>
            <div className='py-4'>
                <p>To,</p>
                <strong className="my-2">SRKAY Consulting Group Pvt. Ltd.</strong>
                <p>{data?.commonDetails?.job_location}</p>
            </div>
            <div className='py-4'>
                <p>I, <b>{data?.employee?.user_display_name}</b> Emp. Code : {data?.employee?.employee_id}  , appointed as <span><b>{data?.employee?.role_on_project} </b></span>– Technology in the Department Management-Support have received the following items from SRKay Consulting Group. </p>
            </div>
            <div>
                <hr></hr>
                <table cellPadding="5" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Nomenclature</th>
                            <th>Quantity</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>
                </table>

                <p className='my-2'>
                    The above items are the property of SRKAY Consulting Group Services, and are issued to me, exclusively for my professional use. I undertake not to misuse the items and also undertake, to reimburse in full the cost of the items for any damage or loss caused to the above items while in my possession.
                </p>
                <div className='d-flex justify-content-between py-4'>
                    <div>
                        Date<br />
                        <b>
                            {dateConvert(data?.employee?.joining_date, "day-mon-year")}
                        </b>
                    </div>
                    <div>
                        Employee Name<br />
                        <b>{data?.employee?.user_display_name}</b>
                    </div>
                    <div>
                        Employee Contact No<br />
                        <b>{data?.employee?.phone_number}</b>
                    </div>
                    <div>
                        Form Provided by<br />
                        <b>IT Support Team.</b>
                    </div>

                </div>
            </div>
            {
                !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                    <button className="btn-default" onClick={onPrev}>Previous</button>
                    <button className='btn-primary' onClick={onNext}>Proceed</button>
                </div>
            }

        </div>
    )
}

export default AssetAllocation